import { render, staticRenderFns } from "./ContentEditableV4.vue?vue&type=template&id=a67e1246"
import script from "./ContentEditableV4.vue?vue&type=script&lang=js"
export * from "./ContentEditableV4.vue?vue&type=script&lang=js"
import style0 from "./ContentEditableV4.vue?vue&type=style&index=0&id=a67e1246&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports